import { ca } from '@cian/analytics';
import { EAdvantageType } from '../../repositories/newbuilding-card/entities/advantages/NewbuildingAdvantageSchema';

export function trackAdvantagesItemClick(label: EAdvantageType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_features_jk',
    label,
  });
}
